import _truncate from 'lodash/truncate'
export const truncate = (text, length = 100) => {
  return _truncate(text, {
    length: length,
    separator: ' ',
  })
}
